'use strict';

const Backbone = require('backbone');
const CommentReaction = require('communication/domain/comment-reaction/reaction');

class CommentReactionCollection extends Backbone.Collection {
    constructor(models, options) {
        super(models, options);

        this.model = CommentReaction;
        this._comment = options.comment;
    }

    static comparator(model) {
        return model.firstActionAt.unix();
    }

    getByName(name) {
        return this.where({name: name})[0];
    }

    hasReaction(name, userKey) {
        let reaction = this.getByName(name);
        if (!reaction) {
            return false;
        }
        return reaction.hasByUserKey(userKey);
    }

    addReaction(name, userKey, actionAt = null) {
        let reaction = this.getByName(name);
        if (!reaction) {
            reaction = new CommentReaction({name: name});
        }

        reaction.addAction(userKey, actionAt)
            .then(() => {
                this.add(reaction);
            });
    }

    removeReaction(name, userKey) {
        const reaction = this.getByName(name);
        if (!reaction) {
            return;
        }

        reaction.removeAction(userKey);
        if (reaction.isEmptyActions()) {
            this.remove(reaction);
        }
    }
}

module.exports = CommentReactionCollection;



// WEBPACK FOOTER //
// ./communication/domain/comment-reaction/reaction-collection.js